(() => {
  const script = document.currentScript;
  const label = script?.dataset.finderLabel;
  const url = script?.dataset.finderUrl;
  if (!label || !url) return;
  let queued = false;
  const addLink = () => {
    queued = false;
    document.querySelectorAll('.gm-level-0').forEach(item => {
      const heading = item.querySelector(':scope > .gm-target .gm-text');
      if (heading?.textContent.trim().toLowerCase() !== 'info') return;
      const list = item.querySelector('.gm-links');
      if (!list || [...list.querySelectorAll('a')].some(a => a.getAttribute('href') === url)) return;
      const row = document.createElement('li');
      row.className = 'gm-item';
      row.dataset.dpFinderNav = 'true';
      const link = document.createElement('a');
      link.className = 'gm-target js-no-transition';
      link.href = url;
      link.title = label;
      const text = document.createElement('span');
      text.className = 'gm-text';
      text.textContent = label;
      link.append(text);
      row.append(link);
      list.append(row);
    });
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(addLink); }
  };
  const start = () => {
    addLink();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
